import React from "react";
import { Box } from "@mui/material";

import { HolidayFormModal } from "./HolidayFormModal";
import { HolidayCalendar } from "./HolidayCalendar";
import { CalendarFunctions } from "../../../../../../components/Calendar";
import { useHolidays, useDeleteHoliday } from "../../../../../../hooks/query/useHolidays";

// eslint-disable-next-line import/prefer-default-export
export function HolidayCalendarSetting(): React.ReactElement {
  const today = new Date();
  const todayBS = CalendarFunctions.convertADtoBS(today);

  const [bsYear, setBsYear] = React.useState(todayBS.bsYear);
  const [bsMonth, setBsMonth] = React.useState(todayBS.bsMonth);

  const currentMonthFirstDate = CalendarFunctions.convertBStoAD(bsYear, bsMonth, 1);
  const fiscalYear = CalendarFunctions.getFiscalYear(currentMonthFirstDate);

  const { data: holidays = [] } = useHolidays({ fiscalYear });
  const { mutate: deleteHolidayMutation } = useDeleteHoliday();

  // modal state
  const [modalOpen, setModalOpen] = React.useState(false);
  const [selectedAdDate, setSelectedAdDate] = React.useState<Date | null>(null);

  // find holiday for selected date
  const selectedHoliday = selectedAdDate
    ? holidays.find((h) => h.date.slice(0, 10) === selectedAdDate.toISOString().slice(0, 10))
    : undefined;

  const handleMonthChange = (newBsYear: number, newBsMonth: number) => {
    setBsYear(newBsYear);
    setBsMonth(newBsMonth);
  };

  const handleDateClick = (adDate: Date) => {
    setSelectedAdDate(adDate);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setSelectedAdDate(null);
  };

  const handleModalSuccess = () => {
    // Queries are invalidated in the mutation hooks
    handleModalClose();
  };

  const handleDeleteHoliday = (id: number) => {
    deleteHolidayMutation(id, {
      onSuccess: () => {
        handleModalClose();
      }
    });
  };

  return (
    <Box sx={{ height: "100%" }}>
      <HolidayCalendar
        bsYear={bsYear}
        bsMonth={bsMonth}
        yearlyHolidays={holidays}
        onDateClick={handleDateClick}
        onMonthChange={handleMonthChange}
      />

      <HolidayFormModal
        open={modalOpen}
        date={selectedAdDate}
        holiday={selectedHoliday}
        onClose={handleModalClose}
        onSuccess={handleModalSuccess}
        onDelete={handleDeleteHoliday}
      />
    </Box>
  );
}
